import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=187da180&scoped=true&"
import script from "./TopMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopMenu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=187da180&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187da180",
  null
  
)

export default component.exports